module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar'), _vm._v(" "), _c('div', {
    staticClass: "uk-margin-remove-top"
  }, [_c('div', {
    staticClass: "uk-container"
  }, [_c('div', {
    staticClass: "uk-grid uk-margin-right"
  }, [_c('div', [_c('a', {
    staticClass: "uk-navbar-item uk-logo",
    attrs: {
      "href": _vm.logoLink
    }
  }, [_c('img', {
    staticStyle: {
      "height": "60px"
    },
    attrs: {
      "src": _vm.config.logo_url,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "auto"
    }
  }, [_c('div', {
    staticClass: "uk-flex"
  }, [_c('h3', {
    staticClass: "uk-col",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('span', {
    staticClass: "uk-h6 uk-text-middle uk-visible@m",
    staticStyle: {
      "cursor": "help"
    },
    attrs: {
      "title": "Jeżeli nie zostanie wykonana żadna akcja w ciągu przedstawionego czasu, nastąpi automatyczne wylogowanie.",
      "uk-tooltip": "pos: bottom"
    }
  }, [_vm._v("Witaj " + _vm._s(_vm.firstName) + " " + _vm._s(_vm.LastName) + ". Sesja wygaśnie za " + _vm._s(_vm.sessionValidToText))])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex"
  }, [_c('router-link', {
    staticClass: "uk-margin-auto-left",
    attrs: {
      "to": {
        name: 'main',
        params: {}
      }
    }
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small uk-margin-auto-left",
    staticStyle: {
      "float": "left",
      "display": "none"
    },
    attrs: {
      "id": "backbtn"
    }
  }, [_vm._v("Wróć do listy wizyt")])])], 1)])]), _vm._v(" "), _c('hr', {
    staticClass: "uk-wdith uk-margin-remove-top uk-divider-icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "uk-container uk-flex uk-flex-wrap uk-margin-top uk-margin-bottom page-wrapper"
  }, [_c('div', {
    staticClass: "uk-width"
  }, [_c('div', {
    staticClass: "uk-grid"
  }, [_c('notifications', {
    staticClass: "uk-background-default"
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-2@m uk-flex uk-flex-stretch uk-margin-remove uk-flex-wrap session-info-wrap"
  }, [_c('div', {
    attrs: {
      "id": "sliderMain"
    }
  }, [_c('carousel', {
    attrs: {
      "auto": 3000,
      "watch-items": _vm.list
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('carousel-item', {
      key: item.url
    }, [_c('img', {
      attrs: {
        "src": item.url
      }
    })])
  }))], 1)])], 1), _vm._v(" "), _c('router-view', {
    staticClass: "uk-width uk-background-default"
  })], 1)]), _vm._v(" "), _c('dashboard-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6622c8a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard.vue
// module id = 271
// module chunks = 1